








































































































































































































import Vue from 'vue'
import AccountMenu from '@/components/AccountMenu.vue'
import AppSearchBar from '@/components/AppSearchBar.vue'
import { goBack } from '@/utility/helpers'
import NotificationsButton from '@/components/NotificationsButton.vue'
import PrintQueue from '@/components/PrintQueue.vue'
import { randomKey } from '@/utility/helpers'
import { trialDays } from '@/utility/helpers'
import { mapGetters } from 'vuex'
export default Vue.extend({
    components: {
        AccountMenu,
        AppSearchBar,
        NotificationsButton,
        PrintQueue
    },
    props: {
        //  Hides the back button (mobile only)
        backHidden: {
            type: Boolean,
            default: false
        },
        displayFull: {
            type: Boolean,
            default: false
        },
        //  Toolbar
        toolbar: {
            type: Object,
            required: false
        },
        //  Decides whether to show the mobile search
        showMobileSearch: {
            type: Boolean,
            default: false
        },
        //  Used for navigation and if in a component with steps
        step: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            trialMenu: false,
            printMenu: false
        }
    },
    mounted() {
        //  Show the search icon for users to access the search page workflow when on any page in app besides the search page
        this.$store.commit('searchBarListVisibleSet', true)
    },
    computed: {
        ...mapGetters([
            'appDrawerIsMin',
            'brand',
            'dataProviderSyncProgress',
            'isApp',
            'meteredRate',
            'plan',
            'printQueue',
            'settings',
            'smsAccount',
            'subscription',
            'tenant',
            'trialing',
            'tutorialItemsComplete'
        ]),
        A2PRegistered(): boolean {
            const a2pEnabled = this.$store.getters.settingGet('a2pEnabled')

            // Ensure that the value isn't null, if it is we don't return it
            return a2pEnabled != null
        },
        creditsTitle(): string {
            //  Grab our tenant's credits
            const credits = this.tenant.credits

            //  Get our total number of credits
            const total = this.totalCredits

            //  If we have 0 credits AND we are not trialing, display Metered
            if (credits === 0 && !this.trialing) return 'Metered'

            //  Else, return our ratio
            return `${Number(credits).toLocaleString()}/${Number(total).toLocaleString()}`
        },
        drawerWidth(): number {
            //  Check if we are at small or below
            const small = this.$vuetify.breakpoint.smAndDown

            //  If we are, just return 0
            if (small) return 0

            //  Check our drawer if it is open or not
            const min = this.appDrawerIsMin

            //  If it's open, return 65
            if (min) return 65

            //  Else, return 190
            return 190
        },
        hotKeysEnabled(): boolean {
            // Checks if our hotkeys are enabled or not
            return this.$store.getters.settingGet('hotKeysEnabled')
        },
        //  Indicates that the tenant is using metered messages (ie, the tenant is over their message allowance)
        metered(): boolean {
            //  If we have a tenant, base this on the tenant credit count
            if (this.tenant) return this.tenant.credits <= 0

            //  Else, no tenant means this is always false
            return false
        },
        onHome(): boolean {
            //  Check our current route
            const route = this.$route.path

            //  If we are at home then return true
            if (route.includes('home')) return true

            //  Else, return false
            return false
        },
        //  Used to set the search icon to be visible or not
        searchBarListVisible: {
            get(): boolean {
                return this.$store.getters.searchBarListVisible
            },
            set(value: boolean): void {
                this.$store.commit('searchBarListVisibleSet', value)
            }
        },
        //  For rerendering the toolbar when the screen size changes
        toolbarRerenderKey() {
            //  If smAndDown scrren sizes, assign a randomKey, this will force the UI to rerender
            if (this.$vuetify.breakpoint.smAndDown) return randomKey()

            //  If mdAndUp scrren sizes, assign a randomKey, this will force the UI to rerender
            if (this.$vuetify.breakpoint.mdAndUp) return randomKey()
        },
        //  Determine if the Credit usage counter should be shown
        showCreditUsage() {
            //  If the screen is too small, do not show
            if (this.$vuetify.breakpoint.xsOnly) return false

            //  Else, if the tenant OR sms account do NOT exist, do not show
            if (!this.tenant || !this.smsAccount) return false

            //  Else, get the workspace setting
            const setting = this.settings.find((x) => x.name === 'showCreditUsage')

            //  If the setting does NOT exist, do not show
            if (!setting) return false

            //  Else, check if the setting is enabled
            const isEnabled = setting.enabled ? true : false

            //  return the enabled state
            return isEnabled
        },
        // Gives us the total number of credits a user is allowed to use before getting metered billing
        totalCredits(): number {
            // If they aren't on a subscription, no credits given
            if (!this.subscription) return 0

            // If they aren't on a plan, no credits given
            if (!this.plan.metadata) return 0

            //  If they are trialing, return 0 as trials no longer can send messages
            if (this.trialing) return 0

            // Store the user's metadata from their plan
            const meta = this.plan.metadata

            // If they have no message allowance on their plan nor do they have credits on a trial plan, no credits given
            if (!meta.message_allowance && !meta.trial_message_allowance) return 0

            // Otherwise get the amount of credits they're allowed to use from one of their plans, either trialing or payment
            const amt =
                parseInt(meta.message_allowance) || parseInt(meta.trial_message_allowance)

            // Return the amount of credits given or 0 in case of edge case
            return amt || 0
        }
    },
    methods: {
        dataProviderRedirect(): void {
            this.$router.push(`/${this.tenant.data_provider.toLowerCase()}`)
        },
        goToUserCreate(): void {
            //  If we are already at the users route, tell our store we want to create
            if (this.$route.path.includes('/teammates')) {
                this.$store.commit('usersCreateSet', true)
            }

            //  Else, we aren't at that route so navigate
            this.$router.push(`/teammates?create=true`)
        },
        //  Navigates user to the new search page for mobile
        goToSearchPage() {
            this.$router.push('/persons/search')
        },
        goToSubscription(): void {
            //  Navigate to the tenants current subscription plan
            // this.$router.push('/billing/plan')
            this.$router.push('/billing/manage')
        },
        goToFreeCredits(): void {
            // Navigate to free credits page
            this.$router.push('/free-credits')
        },
        goToManagePlan(): void {
            //  Get the current plan
            const plan = this.plan

            //  Grab the index from the metadata
            const index = plan.metadata.index

            //  Navigate to manage their own plan
            this.$router.push(`/billing/manage?index=${index}`)
        },
        hideCreditUsage(): void {
            //  Get the credit usage setting
            const setting = this.settings.find((x) => x.name === 'showCreditUsage')

            //  If the setting does NOT exist, do nothing
            if (!setting) return

            //  Else, disable the setting
            setting.enabled = false

            //  Update the setting
            this.$store.dispatch('settingsPut', setting)
        },
        minDrawer(): void {
            this.$emit('minDrawer')
        },
        //  This determines the behavior of the 'back' button...goBack, or handle mobile navaigation
        routeBack(hotKeyPressed: boolean = false): void {
            // True/false value if hotkey was used to activate function
            const hotKeyPressedAndOn = hotKeyPressed && this.hotKeysEnabled.enabled

            // True/false value if click was used to activate function
            const clickPress = !hotKeyPressed

            // If our hotkeys aren't on and the event wasn't activated with a click we leave the function
            if (!hotKeyPressedAndOn && !clickPress) {
                return
            }

            //  Our toolbar's back button
            let btn = this.toolbar.left && this.toolbar.left[0]

            //  If the button has a back callback, it overrides all other handling
            if (this.toolbar.back) return this.toolbar.back(btn)

            //  If we are NOT on a mobile device, we always use the global back function
            if (!this.$vuetify.breakpoint.xsOnly && this.displayFull) return goBack(btn)

            //  Else, If we're on step 1, we use the global back function
            if (this.step === 1) return goBack(btn)

            //  Else, if we're on a step greater than 1, emit step change to one less
            if (this.step > 1) this.$emit('setStep', this.step - 1)
        },
        trialDays(): string {
            return trialDays()
        },
        toggleDrawer(): void {
            this.$store.commit('appDrawerToggle')
        }
    }
})
